/**
 * Audit Logs Schema
 * Tracks security-relevant operations for compliance and debugging.
 */

import { pgTable, uuid, varchar, text, timestamp, jsonb } from 'drizzle-orm/pg-core';

// =============================================================================
// Audit Logs Table
// =============================================================================
export const auditLogs = pgTable('audit_logs', {
  id: uuid('id').primaryKey().defaultRandom(),
  userId: uuid('user_id'), // null for unauthenticated actions
  action: varchar('action', { length: 100 }).notNull(), // 'auth.signup', 'offering.create', etc.
  resource: varchar('resource', { length: 100 }), // 'user', 'offering', 'transaction'
  resourceId: uuid('resource_id'),
  ipAddress: varchar('ip_address', { length: 45 }), // IPv6-compatible
  userAgent: text('user_agent'),
  metadata: jsonb('metadata').default({}),
  createdAt: timestamp('created_at').defaultNow().notNull(),
});

// =============================================================================
// Types
// =============================================================================
export type AuditLog = typeof auditLogs.$inferSelect;
export type NewAuditLog = typeof auditLogs.$inferInsert;
